import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { LocalizationService } from '../modules/localization/localization.service';
import { take } from 'rxjs/operators';

@Injectable()
export class PageNotFoundGuard implements CanActivate {
  constructor(private _localizationService: LocalizationService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this._localizationService.isTranslationsReady().pipe(take(1));
  }
}
